import type { RootState } from 'app/store/reducers';

export const selectError = (state: RootState) => state.error;
